<div class="esf-accordion__unit">
  <div class="esf-accordion__trigger -is-open">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
      <span class="esf-action-heading__text" i18n='Section title@@club.heading.websiteSettings'>Website Settings</span>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">

          <button class="esf-button esf-button--simple"
                  (click)="clubOverviewService.toggleAllModal(false);clubOverviewService.toggleEditWebsiteModal(true);$event.stopPropagation();"
                  [edsTooltip]="tooltipTranslations.i18nEdit">
            <svg class="esf-icon esf-button__icon" width="16" height="16">
              <use xlink:href="#esf-icon-edit"></use>
            </svg>
            <span class="esf-button__icon-text"></span>
          </button>

        </span>
      </span>
    </h4>
  </div>

  <div class="esf-accordion__target -is-open">

    <div class="esf-info-tile esf-info-tile--full-width">
      <div class="esf-info-tile__content">

        <table class="esf-table">
          <thead class="esf-table__head">
            <tr class="esf-table__row">
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.title' data-label="Title">
                <span i18n='Table cell heading@@general.tableCellLabel.title' class="esf-table__cell-inner">Title</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.headerColor' data-label="Header Color">
                <span i18n='Table cell heading@@general.tableCellLabel.headerColor' class="esf-table__cell-inner">Header Color</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.footerColor' data-label="Footer Color">
                <span i18n='Table cell heading@@general.tableCellLabel.footerColor' class="esf-table__cell-inner">Footer Color</span>
              </th>
            </tr>
          </thead>
          <tbody class="esf-table__body">
            <tr class="esf-table__row">
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.title' data-label="Title">
                <span class="esf-table__cell-inner">{{ selectedClub.website?.title }}</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.headerColor' data-label="Header Color">
                <span class="esf-table__cell-inner">{{ selectedClub.website?.headerColor }}</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.footerColor' data-label="Footer Color">
                <span class="esf-table__cell-inner">{{ selectedClub.website?.footerColor }}</span>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
</div>
